import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useConvertToAgent = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [convertToAgentLoading, setConvertToAgentLoading] = useState(false);

  const convertToAgentRequest = ({ userGUID, zoneGUID, onSuccess }) => {
    setConvertToAgentLoading(true);
    axiosClient
      .post(
        `SettingAccount/ConvertToAgent?GUID=${userGUID}&ZoneGuid=${zoneGUID}`,
      )
      .then(res => {
        if (res.status === 200) {
          enqueueSnackbar(`تبدیل به ایجنت با موفقیت انجام شد`, {
            variant: 'success',
          });
          onSuccess?.();
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        console.log(err);
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => setConvertToAgentLoading(false));
  };
  return { convertToAgentRequest, convertToAgentLoading };
};
export default useConvertToAgent;
